export const categories = [
  {
    id: "线索速报",
    name: "线索速报",
    icon: "ri-flashlight-line",
    desc: "第一时间记录刚流出的线索，先存档、再求证。",
    count: 148,
  },
  {
    id: "反转现场",
    name: "反转现场",
    icon: "ri-loop-left-line",
    desc: "前后说法对不上？这里专门收拢被打翻的旧结论。",
    count: 96,
  },
  {
    id: "当事人回应",
    name: "当事人回应",
    icon: "ri-reply-line",
    desc: "工作室声明、本人发声、律师函，一文看清各方口径。",
    count: 74,
  },
  {
    id: "瓜田盘点",
    name: "瓜田盘点",
    icon: "ri-layout-grid-line",
    desc: "把散落的时间线拼成完整脉络，复盘一整段时间的瓜田。",
    count: 62,
  },
];

export const statusMeta = {
  追踪中: { color: "primary", icon: "ri-radar-line" },
  已反转: { color: "accent", icon: "ri-loop-left-line" },
  已回应: { color: "secondary", icon: "ri-chat-check-line" },
} as const;

export type StoryStatus = keyof typeof statusMeta;